import React from 'react';
import Leaflet from 'leaflet';
import MarkerPopup from './MarkerPopup';
import { MapLayer } from 'react-leaflet';

require('leaflet.markercluster');
require('stylesheets/leaflet/divicon');
require('stylesheets/leaflet/MarkerCluster');
require('stylesheets/leaflet/MarkerCluster.Default');

class MarkerCluster extends MapLayer {
  componentWillMount() {
    super.componentWillMount();
    this.leafletElement = Leaflet.markerClusterGroup(
      {
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        animateAddingMarkers: true
      });
  }

  componentWillReceiveProps(nextProps) {
    super.componentWillReceiveProps(nextProps);
    // add markers to cluster layer
    if (nextProps.newMarkerData.length > 0 && !nextProps.isRendered) {
      const markers = Object.assign({}, this.props.markers);
      const newMarkers = [];

      nextProps.newMarkerData.forEach((obj) => {
        let markerPopup = null;
        markerPopup = React.renderToStaticMarkup(
        <MarkerPopup
          projectid = {obj.project_id}
          title= {obj.project_title}
          draftestimates = {this.formaNnumber(obj.draft_estimated_kes)}
          duration = {obj.duration}
          donor = {obj.funder3}
          fundingtype = {obj.funding_type}
          status = {obj.implementation_status}
          implagency = {obj.implementing_agency}
          program = {obj.program}
          description = {obj.project_description}
          objetives = {obj.project_objectives}
          totalestimated = {this.formaNnumber(obj.total_estimates_for_2015)}
        />);
        
        const divIcon = Leaflet.divIcon({className: 'div-icon'});
        const leafletMarker = Leaflet.marker(obj.location, {icon: divIcon})
          .bindPopup(markerPopup, {maxHeight: 400, maxWidth: 310, minWidth: 250})
          .on('click', () => this.props.map.panTo(obj.position));

        markers[obj.PROJECT_ID] = leafletMarker;
        newMarkers.push(leafletMarker);
      });

      this.leafletElement.clearLayers();
      this.leafletElement.addLayers(newMarkers);
    }

    // zoom to particular marker
    if (Object.keys(nextProps.focusMarker).length > 0) {
      const marker = this.props.markers[nextProps.focusMarker.id];

      this.leafletElement.zoomToShowLayer(marker, () => {
        this.props.map.panTo(nextProps.focusMarker.position);
        marker.openPopup();
      });
    }
  }

  shouldComponentUpdate() {
    return false;
  }

   /**
   * [formaNnumber description]
   * @param  {[type]} n [description]
   * @return {[type]}   [description]
   */
  formaNnumber(n) {
    if (n !== '0' && n !== undefined) {
      return n;
    } else {
      return '0';
    }
  }

  render() {
    return null;
  }
}

MarkerCluster.propTypes = {
  focusMarker: React.PropTypes.object,
  map: React.PropTypes.object,
  markers: React.PropTypes.object,
  newMarkerData: React.PropTypes.array,
  type: React.PropTypes.string,
  updateMarkers: React.PropTypes.func,
};

MarkerCluster.defaultProps = {
  markers: {},
  newMarkerData: [],
  focusMarker: {},
};

export default MarkerCluster;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/map/MarkerCluster.jsx
 **/